<template>
  <div class="builder">
    <div v-if="activeStep === '1'" class="builder__container">
      <div class="builder__pretitle">Report Type</div>
      <div class="builder__title">What are you looking for?</div>
      <div class="builder__types">
        <div
          v-for="(type, index2) in types"
          :key="index2"
          class="builder__type"
          @click="selectType(type.type)"
        >
          {{ type.label }}
        </div>
      </div>
    </div>
    <div v-if="activeStep === '2'" class="builder__container">
      <div class="builder__pretitle">Customisation</div>
      <div v-if="reportType === 'country'">
        <div class="builder__title">Select your country</div>
        <div class="builder__checkboxs" />
      </div>

      <div v-if="reportType === 'requirement'">
        <div class="builder__title">Select your license names.</div>
        <div class="builder__checkboxs">
          <el-checkbox-group v-model="chosenLicenses">
            <el-checkbox v-for="item in licenses" :key="item" :label="item" />
          </el-checkbox-group>
        </div>
      </div>
    </div>
    <div v-if="activeStep === '3'" class="builder__container">
      <div class="builder__pretitle">Jurisdictions</div>
      <div class="builder__title">Add your jurisdictions</div>
      <div class="builder__checkboxs" />
    </div>
    <div v-if="activeStep === '4'" class="builder__container">
      <div class="builder__pretitle">Custom report</div>
      <div class="builder__title">Content...</div>
      <div class="builder__checkboxs" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Builder",
  components: {
    // TitleBlock: () => import("@/components/elements/TitleBlock"),
  },
  data() {
    // The steps headings below can of course be changed, I couldn't remember what they had changed to from the original design
    return {
      isOpen: false,
      chosenItemsType: [],
      chosenLicenses: [],
      stepTitles: [
        "What are you looking for?",
        "Select your licenses",
        "Select your jurisdictions",
        "Select your products",
        "View your custom report",
      ],
      checkAllJurisdictions: false,
      types: [
        {
          type: "country",
          label: "Country reports",
        },
        {
          type: "requirement",
          label: "Requirements",
        },
      ],
      fields: [
        {
          tid: "country",
          checkboxLabel: "Country reports",
        },
      ],
    };
  },
  computed: {
    ...mapState("ReportBuilder", [
      "activeStep",
      "reportType",
      "licenses",
      "selectedProducts",
      "selectedLicenses",
      "selectedJurisdictions",
      "selectedSpecialisms",
    ]),
  },
  methods: {
    selectType(type) {
      this.$store.commit("ReportBuilder/setData", {
        label: "reportType",
        data: type,
      });
      this.$store.commit("ReportBuilder/setData", {
        label: "activeStep",
        data: "2",
      });
      this.$store.commit("ReportBuilder/setStepStateData", {
        label: "stepState",
        data: 3,
      });

      if (type === "requirement") {
        this.$store
          .dispatch("ReportBuilder/getViewData", {
            url: "/report-builder/requirement-license-names",
          })
          .then(({ data }) => {
            this.$store.commit("ReportBuilder/setData", {
              label: "licenses",
              data,
            });
          })
          .catch((error) => console.error(error));
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";

.builder {
  padding: 3rem;

  &__container {
    // padding: 3rem;
  }

  &__title {
    margin-bottom: 1rem;
    color: #262a2e;
    font-size: 2.8rem;
    line-height: 3.3rem;
    font-weight: 700;
    text-decoration: none;
  }

  &__pretitle {
    margin-bottom: 1rem;
    color: #262a2e;
    font-size: 1.8rem;
    line-height: 3.3rem;
    font-weight: 700;
    text-decoration: none;
  }

  padding-top: 0;

  .select-all {
    background: none;
    border: none;
    color: $red;
    font-size: 1.4rem;
    font-weight: 600;
    position: absolute;
    right: 5rem;
    top: 1rem;
    z-index: 1;

    .el-checkbox__input {
      display: none;
    }
  }

  .continue {
    background: $red;
    border: 1px solid $red;
    color: $white;
    font-size: 1.8rem;
    font-weight: 700;
    height: 4rem;
    padding: 0 2rem;
    display: flex;
    align-items: center;
    justify-content: center;

    &.is-disabled {
      background: #425563;
      border: 1px solid #425563;
    }
  }

  &__steps {
    border-top: 1px solid $border;
    border-bottom: 1px solid $border;
    display: flex;
    justify-content: center;
    background: #dce1e4;

    @include below($md) {
      display: none;
    }
  }

  &__step {
    width: 25rem;
    height: 8rem;
    color: $white;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-left: 2rem;
    background: $light_gray;
    border-right: 1px solid $white;

    &.active {
      background: $red;
    }

    &.checked {
      background: $text;
      position: relative;

      &:after {
        content: "";
        background: url("../../assets/icons/i_checked.svg") no-repeat;
        background-size: 100%;
        width: 1.4rem;
        height: 1.4rem;
        position: absolute;
        right: 1rem;
        top: 1rem;
      }
    }

    &-count {
      text-transform: uppercase;
      font-size: 1.2rem;
      font-weight: 600;
    }

    &-name {
      font-size: 1.8rem;
    }
  }

  &__steps-mobile {
    width: 180px;
    margin: 0 auto;
    display: none;
    justify-content: space-between;
    align-items: center;
    margin-top: 2rem;

    @include below($md) {
      display: flex;
    }
  }

  &__step-mobile {
    position: relative;
    width: 25px;
    height: 25px;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    background-color: #768692;
    border-radius: 50%;
    border: 1px solid #ffffff;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);

    &-count {
      font-size: 14px;
      font-weight: 500;
      color: rgba(255, 255, 255, 0.75);
    }

    &.active {
      background: #da291c;
    }

    &.checked {
      background: #1f2a44;

      &:before {
        content: "";
        background: url("../../assets/icons/i_checked.svg") no-repeat;
        background-size: 100%;
        width: 11px;
        height: 7.5px;
        position: absolute;
        top: calc(50% - 3.75px);
      }

      &:not(:last-child):after {
        content: "";
        width: calc(100% + 25px);
        height: 2px;
        background: #1f2a44;
        position: absolute;
        right: calc(-100% - 25px);
        top: calc(50% - 1px);
      }
    }

    &.active &-count {
      color: #fff;
    }

    &.checked &-count {
      color: transparent;
    }

    &:not(:last-child):after {
      content: "";
      width: calc(100% + 25px);
      height: 2px;
      background: rgba(118, 134, 146, 0.25);
      position: absolute;
      right: calc(-100% - 25px);
      top: calc(50% - 1px);
    }
  }

  // &__title {
  //   margin-top: 5rem;

  //   @include below($md) {
  //     margin-top: 3rem;
  //   }
  // }
  &__subtitle {
    margin-top: 3rem;
    font-size: 2.6rem;
    font-weight: 700;
    display: flex;
    align-items: center;

    @include below($md) {
      font-size: 2rem;
      position: relative;
      margin-left: 3rem;
    }

    &:before {
      content: "";
      width: 1.5rem;
      height: 1.5rem;
      border-radius: 50%;
      border: 2px solid $text_gray;
      background: #8dc8e8;
      margin-right: 1.2rem;

      @include below($md) {
        position: absolute;
        top: 2px;
        left: -2.5rem;
      }
    }
  }

  &__questions {
    display: flex;
    justify-content: flex-start;
    padding: 4rem 4rem 4rem 0;

    @include below($md) {
      border: none !important;
      flex-direction: column;
      padding-right: 0;
    }
  }

  &__question {
    border: 2px solid #8dc8e8;
    border-radius: 0.6rem;
    font-size: 1.8rem;
    line-height: 2.3rem;
    color: $text;
    padding: 2rem 2.6rem;
    margin-right: 2rem;
    width: 24.5%;
    transition: 0.3s ease-out;
    cursor: pointer;

    &:hover,
    &.active {
      color: $white;
      background: $blue;
      border: 2px solid $blue;
    }

    &-arrow {
      display: none;

      @include below($md) {
        display: block;
        margin-left: 1rem;
      }
    }

    @include below($md) {
      width: auto;
      margin-bottom: 0.5em;
      display: flex;
      align-items: center;
    }
  }

  &__sections {
    padding: 4rem 4rem 2.8rem 0;
    position: relative;

    .accordion {
      margin-bottom: 1rem;
    }

    &-item {
      position: relative;
    }

    @include below($md) {
      padding-right: 0;
      border: none !important;
    }

    .el-collapse-item__content {
      @include below($md) {
        padding-right: 0;
      }
    }

    &-wrapper--hide {
      position: relative;

      &:after {
        content: "";
        width: 100%;
        height: 100%;
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
        background: rgba(255, 255, 255, 0.7);
      }
    }

    &-buttons {
      display: flex;
    }
  }

  &__sections > .select-all {
    @include below($md) {
      right: 0;
    }
  }

  &__jurisdictions {
    padding-right: 4rem;

    @include below($md) {
      padding-right: 0;
      border: none;
    }

    .accordion .el-collapse-item__content {
      padding-right: 0;
      border: none;
    }
  }

  &__jurisdiction {
    position: relative;
    margin: 0.5rem 0;

    &:last-of-type {
      margin: 0;
    }

    .report-builder__checkboxs {
      .el-checkbox-group {
        display: flex;
        flex-wrap: wrap;
        margin-right: -0.5%;
      }

      &-wrapper {
        width: 24.5%;
        margin-right: 0.5%;
        margin-bottom: 1.2rem;
        @include below($md) {
          width: 100%;
          margin-bottom: 0.5rem;
        }
      }

      .with-child {
        width: 100%;
        margin-right: 0;

        & > div {
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          margin-right: -0.5%;

          & > div.visible-item {
            width: 24.5%;
            margin-right: 0.5%;
            @include below($md) {
              width: 100%;
            }

            .el-checkbox {
              width: 100%;
            }
          }
        }

        & > .el-checkbox {
          width: 24.5%;
        }
      }

      .el-checkbox {
        width: 100%;
        min-height: 4.4rem;
        border: 2px solid #8dc8e8;
        border-radius: 0.6rem;
        display: flex;
        align-items: center;
        padding-left: 2rem;
        padding-right: 5rem;
        font-size: 1.6rem;
        position: relative;
        white-space: normal;
        color: $text_gray;

        &:after {
          content: "";
          background: url("../../assets/icons/i_tick.svg") no-repeat;
          background-size: 100%;
          width: 1.8rem;
          height: 1.8rem;
          position: absolute;
          right: 1.4rem;
          top: 0.9rem;
          display: none;
        }

        &.is-disabled {
          cursor: not-allowed;

          &:hover {
            background: none;
            border: 2px solid #8dc8e8;
            color: $text_gray;
          }
        }

        &:hover {
          background: $blue;
          border: 2px solid $blue;
          color: $white;
        }

        @include below($md) {
          width: 100%;
        }

        &.is-checked {
          background: $blue;
          border: 2px solid $blue;

          &:after {
            display: block;
          }

          .country {
            color: $white;
          }
        }

        &__input {
          &.is-checked + .el-checkbox__label {
            color: $white !important;
          }

          display: none;
        }
      }

      &--full {
        .el-checkbox {
          width: 100%;
        }
      }
    }
  }

  &__checkboxs {
    .el-checkbox-group {
      display: flex;
      flex-wrap: wrap;
      margin-right: -0.5%;
    }

    .el-checkbox {
      width: 24.5%;
      min-height: 4.4rem;
      border: 2px solid #8dc8e8;
      border-radius: 0.6rem;
      display: flex;
      align-items: center;
      padding-left: 2rem;
      padding-right: 5rem;
      font-size: 1.6rem;
      margin-right: 0.5%;
      margin-bottom: 1.2rem;
      position: relative;
      white-space: normal;

      &:after {
        content: "";
        background: url("../../assets/icons/i_tick.svg") no-repeat;
        background-size: 100%;
        width: 1.8rem;
        height: 1.8rem;
        position: absolute;
        right: 1.4rem;
        top: 0.9rem;
        display: none;
      }

      &:hover {
        background: $blue;
        border: 2px solid $blue;
        color: $white;
      }

      @include below($md) {
        width: 100%;
      }

      &.is-checked {
        background: $blue;
        border: 2px solid $blue;

        &:after {
          display: block;
        }

        .country {
          color: $white;
        }
      }

      &__input {
        &.is-checked + .el-checkbox__label {
          color: $white !important;
        }

        display: none;
      }
    }

    &--full {
      .el-checkbox {
        width: 100%;
      }
    }
  }

  &__no-result {
    display: flex;
    align-items: center;
    padding-top: 4rem;
    font-size: 1.8rem;
    font-weight: 700;

    .button {
      margin-left: 2rem;
    }
  }

  .report-slider__top {
    @include below($md) {
      padding-bottom: 7rem;
    }
  }

  .customer-report__section-slider {
    width: auto;
  }

  .customer-report {
    @include below($sm) {
      padding-left: 3rem;
      padding-right: 3rem;
    }
  }

  .customer-report__header {
    @include below($md) {
      width: auto;
    }
  }

  .builder__types {
    display: flex;

    .builder__type {
      border: 1px solid black;
      border-radius: 2px;
      padding: 1rem;
      margin-right: 1rem;
      cursor: pointer;
    }
  }
}
</style>
